import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { slugify } from "../../lib/format";
import { panel, inputCls, btnPrimary, btnGhost, Field, PageHead } from "../ui";
import { Trash2, ArrowUpToLine } from "lucide-react";

export default function Categories() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: "", parent_id: "", description: "", image: "" });

  const load = () => admin.get("/admin/categories").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name) return;
    await admin.post("/admin/categories", { ...form, slug: slugify(form.name), parent_id: form.parent_id || null });
    setForm({ name: "", parent_id: "", description: "", image: "" }); toast.success("Added"); load();
  };
  const promote = async (c) => { await admin.post(`/admin/categories/${c.id}/promote`); toast.success("Promoted to top level"); load(); };
  const del = async (c) => { if (!window.confirm(`Delete ${c.name}?`)) return; try { await admin.delete(`/admin/categories/${c.id}`); load(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };

  return (
    <div>
      <PageHead title="Categories" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className={`${panel} p-5 space-y-3 h-fit`}>
          <p className="text-sm font-semibold text-white uppercase tracking-wider">Add Category</p>
          <Field label="Name"><input className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="category-name" /></Field>
          <Field label="Parent">
            <select className={inputCls} value={form.parent_id} onChange={(e) => setForm({ ...form, parent_id: e.target.value })}>
              <option value="">— None (top level) —</option>
              {list.filter((c) => !c.parent_id).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
          <Field label="Image URL"><input className={inputCls} value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} /></Field>
          <Field label="Description"><input className={inputCls} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></Field>
          <button onClick={add} className={btnPrimary} data-testid="category-add-btn">Add Category</button>
        </div>

        <div className={`${panel} p-5 lg:col-span-2`}>
          <div className="space-y-1">
            {list.map((c) => (
              <div key={c.id} className="flex items-center justify-between py-2 border-b border-zinc-900">
                <span className="text-sm text-zinc-200">{c.parent_id ? <span className="text-zinc-600">— </span> : null}{c.name} <span className="text-[11px] text-zinc-600">/{c.slug}</span></span>
                <div className="flex gap-3">
                  {c.parent_id && <button onClick={() => promote(c)} className="text-zinc-400 hover:text-accent" title="Promote to top level" data-testid={`promote-${c.slug}`}><ArrowUpToLine size={15} /></button>}
                  <button onClick={() => del(c)} className="text-zinc-400 hover:text-red-400"><Trash2 size={15} /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
